var _defs, _rect, _rect2, _tspan, _rect3, _rect4, _tspan2, _rect5, _rect6, _g, _rect7, _rect8, _g2, _rect9, _rect10, _rect11, _path, _path2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 300,
    viewBox: "0 0 132.29 79.375",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.652,
    y: 0.49217,
    width: 104.99,
    height: 78.391,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#fff",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.45518
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.652,
    y: 0.46309,
    width: 104.99,
    height: 78.449,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#fff",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.39702
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.772,
    y: 2.5519,
    width: 29.493,
    height: 19.273,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), /*#__PURE__*/React.createElement("text", {
    x: 24.91313,
    y: 15.907614,
    fill: "#0100ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "5.0232px",
    strokeMiterlimit: 10,
    strokeWidth: 0.3588,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 24.91313,
    y: 15.907614,
    fill: "#0100ff",
    strokeWidth: 0.3588
  }, "$17M"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 4.1012,
    width: 14.295,
    height: 2.8704,
    rx: 1.0583,
    ry: 1.0583,
    fill: "#8080ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51.399,
    y: 2.5519,
    width: 29.493,
    height: 19.273,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), /*#__PURE__*/React.createElement("text", {
    x: 60.789692,
    y: 15.907614,
    fill: "#0100ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "5.0232px",
    strokeMiterlimit: 10,
    strokeWidth: 0.3588,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 60.789692,
    y: 15.907614,
    fill: "#0100ff",
    strokeWidth: 0.3588
  }, "184"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53.137,
    y: 4.1012,
    width: 14.295,
    height: 2.8704,
    rx: 1.0583,
    ry: 1.0583,
    fill: "#8080ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 86.026,
    y: 2.5519,
    width: 29.493,
    height: 19.273,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0064725 -.0095958 .0095958 .0064725 90.965 15.664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m534.37 632.86v-483.28c0.28125-10.406-9.3281-19.125-19.734-18.422-246.52 18.047-439.64 225.89-439.64 473.34-4.4062 352.64 388.26 588.84 697.22 419.34 9.4219-4.7344 12.797-17.719 6.6094-26.531l-244.5-364.45z",
    fill: "#5252ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1122.1 699.37c-2.9531-4.5938-7.7344-7.5469-13.078-8.2969l-477.42-66.141c-15.984-2.8125-27.562 17.391-16.969 29.672l285.24 358.92c5.9062 7.4062 16.5 9.2812 24.328 4.0312 100.03-63.375 170.26-202.87 199.92-303.1 1.6406-4.9688 0.75-10.688-2.0156-15.094z",
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m610.82 578.16h421.22c10.547 0.1875 19.359-9.4219 18.422-19.922-16.969-232.74-205.26-421.22-438.14-438.14-10.312-0.70312-20.109 7.875-19.922 18.422v421.22c0 10.125 8.2969 18.422 18.422 18.422z",
    fill: "#4e35b0"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87.686,
    y: 4.1012,
    width: 14.295,
    height: 2.8704,
    rx: 1.0583,
    ry: 1.0583,
    fill: "#8080ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 86.026,
    y: 25.862,
    width: 29.493,
    height: 19.273,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.29336 -.514 0 126.84 67.531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.352 73.08h-5.4667v-24.173h5.467l-1.19e-4 24.173z",
    fill: "#b3b3ff",
    strokeWidth: 0.032876
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.331 73.08h-5.467v-18.762l5.467 1.58e-4z",
    fill: "#6766ff",
    strokeWidth: 0.032876
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.4 73.08h-5.467v-28.16h5.467z",
    fill: "#8080ff",
    strokeWidth: 0.032705
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.37 73.08h-5.4667v-32.072h5.4667z",
    fill: "#33f",
    strokeWidth: 0.032876
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 87.686,
    y: 27.411,
    width: 14.295,
    height: 2.8704,
    rx: 1.0583,
    ry: 1.0583,
    fill: "#8080ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 86.026,
    y: 48.702,
    width: 29.493,
    height: 19.273,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 87.686,
    y: 50.251,
    width: 14.295,
    height: 2.8704,
    rx: 1.0583,
    ry: 1.0583,
    fill: "#8080ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m89.165 65.506 4.569-6.5719 7.0727 3.938 4.8461-3.5639 6.8772-2.9987",
    fill: "none",
    stroke: "#8ecb86",
    strokeMiterlimit: 10,
    strokeWidth: 0.45518
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m89.006 63.092h4.9352l6.8652-4.4139 4.9888 2.148 6.6265-7.3894",
    fill: "none",
    stroke: "#2680d9",
    strokeMiterlimit: 10,
    strokeWidth: 0.45518
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.4351)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(0 -1.4351)",
    x: 16.772,
    y: 25.862,
    width: 64.171,
    height: 42.162,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1.4351)",
    fill: "none",
    stroke: "#94b3d1",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.846 37.74v24.268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.345 37.74v24.268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.843 37.74v24.268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.334 57.348 49.757-3.9e-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.334 52.454 49.757-3.8e-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.334 47.559 49.757-3.8e-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.334 42.651 49.757-3.8e-5"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 24.334,
    y: 37.74,
    width: 49.757,
    height: 24.268,
    rx: 0.52917,
    ry: 0.52917,
    strokeWidth: 0.24972
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 25.976,
    width: 14.295,
    height: 2.8704,
    rx: 1.0583,
    ry: 1.0583,
    fill: "#8080ff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.772,
    y: 71.583,
    width: 29.493,
    height: 19.273,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 73.132,
    width: 14.295,
    height: 2.8704,
    rx: 1.0583,
    ry: 1.0583,
    fill: "#8080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.399,
    y: 71.583,
    width: 29.493,
    height: 19.273,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.137,
    y: 73.132,
    width: 14.295,
    height: 2.8704,
    rx: 1.0583,
    ry: 1.0583,
    fill: "#8080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.026,
    y: 71.583,
    width: 29.493,
    height: 19.273,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.686,
    y: 73.132,
    width: 14.295,
    height: 2.8704,
    rx: 1.0583,
    ry: 1.0583,
    fill: "#8080ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormDashboard);
export default __webpack_public_path__ + "static/media/form-dashboard.01a42762a90c378a872f4a3d559d630d.svg";
export { ForwardRef as ReactComponent };